// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-resume {
  border: 1px solid #e1e9ef;
  border-radius: 8px;
  height: 230px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;
  align-items: start;
  box-shadow: 0px 3px 3px 0px #373d43;
}

.item {
  display: flex;
  align-items: center;
  width: 100%; /* Ocupa todo el ancho del contenedor padre */
  /* padding: 0 16px; */
  height: 72px;
  margin-bottom: 8px;
}

.item img {
  margin-right: 8px;
  padding-left: 16px;
}

.label {
  flex-grow: 1; /* Ocupa todo el espacio sobrante */
  font-weight: bold;
}

.value {
  font-size: 16px;
  font-weight: 400;
  text-align: right;
  white-space: nowrap; /* Evita que el texto se rompa en varias líneas */
  padding-right: 16px;
}

.item:last-child {
  margin-bottom: 0;
}

.col-container {
  display: flex;
  max-width: 1232px;
  width: 100%;
  justify-content: space-between;
  gap: 2.5rem;
}

.select-container.selct-with-border {
  border: 1px solid #373d43;
  border-radius: 8px;
  height: 36px;
  padding: 5px;
}

.shipping-cost-container {
  border-radius: 8px;
  padding: 16px;
  min-height: 658px;
  min-width: 339px;
  background: rgb(71 147 239 / 30%);
  text-align: left;
  box-shadow: 0px 3px 3px 0px #373d43;
}

.shipping-cost-container h2 {
  font-family: Nunito;
  font-size: 18px;
  font-weight: 800;
  line-height: 26px;
  text-align: left;
}

.shipping-item {
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  color: #373d43;
}

.shipping-item span {
  font-size: 16px;
  font-weight: 800;
  line-height: 26px;
  text-align: right;
  color: #373d43;
}

.shipping-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.warning-remitente{
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  color: #373d43;
  background-color: #ffe100;
  padding: 5px;
  border-radius: 3px;
}

.shipping-item.total {
  margin-top: 15px;
}

hr {
  border: none;
  border-top: 1px solid #ffffff;
  margin: 8px 0;
}

.second-step {
  padding: 20px 100px 60px 100px;
}

.split-divide {
  border: 1px solid gray;
}

.shipping-item.total {
  font-weight: bold;
  margin-top: 8px;
}

.item img {
  margin-right: 7px;
}

.item .value {
  color: #373d43;
  font-size: 16px;
  font-weight: 400;
  line-height: 21.82px;
  width: 3.5rem;
  text-align: right;
}

.col-inpust {
  max-width: 573px;
  width: 100%;
}

.first-step-container-resume {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.link-blue {
  color: #4793ef;
  font-family: Nunito;
  font-size: 16px;
  font-weight: 800;
  text-align: center;
  cursor: pointer;
  width: 180px;
  height: 40px;
  line-height: 40px;
}

.usa-select-input-provider {
  height: 300px;
}

.actions-container {
  display: flex;
  justify-content: end;
  width: 100%;
}

.col-details-mobile {
  display: none;
}

@media (max-width: 1100px) {
  .second-step {
    padding: 20px 3% 60px 3%;
  }

  .col-inpust {
    width: 100%;
  }

}

@media (max-width: 930px) {
  .col-details {
    display: none;
  }

  .col-details-mobile {
    display: block;
  }

  .col-inpust {
    width: 100%;
    flex: 1;
    max-width: none;
  }
  .usa-select-input-provider {
    height: auto;
  }

  .actions-container {
    margin-top: 20px;
  }
  .col-container {
    justify-content: space-around;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SecondStep/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW,EAAE,6CAA6C;EAC1D,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY,EAAE,mCAAmC;EACjD,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB,EAAE,iDAAiD;EACtE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;AAEF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,OAAO;IACP,eAAe;EACjB;EACA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".content-resume {\n  border: 1px solid #e1e9ef;\n  border-radius: 8px;\n  height: 230px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 20px;\n  align-items: start;\n  box-shadow: 0px 3px 3px 0px #373d43;\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  width: 100%; /* Ocupa todo el ancho del contenedor padre */\n  /* padding: 0 16px; */\n  height: 72px;\n  margin-bottom: 8px;\n}\n\n.item img {\n  margin-right: 8px;\n  padding-left: 16px;\n}\n\n.label {\n  flex-grow: 1; /* Ocupa todo el espacio sobrante */\n  font-weight: bold;\n}\n\n.value {\n  font-size: 16px;\n  font-weight: 400;\n  text-align: right;\n  white-space: nowrap; /* Evita que el texto se rompa en varias líneas */\n  padding-right: 16px;\n}\n\n.item:last-child {\n  margin-bottom: 0;\n}\n\n.col-container {\n  display: flex;\n  max-width: 1232px;\n  width: 100%;\n  justify-content: space-between;\n  gap: 2.5rem;\n}\n\n.select-container.selct-with-border {\n  border: 1px solid #373d43;\n  border-radius: 8px;\n  height: 36px;\n  padding: 5px;\n}\n\n.shipping-cost-container {\n  border-radius: 8px;\n  padding: 16px;\n  min-height: 658px;\n  min-width: 339px;\n  background: rgb(71 147 239 / 30%);\n  text-align: left;\n  box-shadow: 0px 3px 3px 0px #373d43;\n}\n\n.shipping-cost-container h2 {\n  font-family: Nunito;\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 26px;\n  text-align: left;\n}\n\n.shipping-item {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  text-align: left;\n  color: #373d43;\n}\n\n.shipping-item span {\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 26px;\n  text-align: right;\n  color: #373d43;\n}\n\n.shipping-item {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.warning-remitente{\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  text-align: center;\n  color: #373d43;\n  background-color: #ffe100;\n  padding: 5px;\n  border-radius: 3px;\n}\n\n.shipping-item.total {\n  margin-top: 15px;\n}\n\nhr {\n  border: none;\n  border-top: 1px solid #ffffff;\n  margin: 8px 0;\n}\n\n.second-step {\n  padding: 20px 100px 60px 100px;\n}\n\n.split-divide {\n  border: 1px solid gray;\n}\n\n.shipping-item.total {\n  font-weight: bold;\n  margin-top: 8px;\n}\n\n.item img {\n  margin-right: 7px;\n}\n\n.item .value {\n  color: #373d43;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 21.82px;\n  width: 3.5rem;\n  text-align: right;\n}\n\n.col-inpust {\n  max-width: 573px;\n  width: 100%;\n}\n\n.first-step-container-resume {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.link-blue {\n  color: #4793ef;\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: 800;\n  text-align: center;\n  cursor: pointer;\n  width: 180px;\n  height: 40px;\n  line-height: 40px;\n}\n\n.usa-select-input-provider {\n  height: 300px;\n}\n\n.actions-container {\n  display: flex;\n  justify-content: end;\n  width: 100%;\n}\n\n.col-details-mobile {\n  display: none;\n}\n\n@media (max-width: 1100px) {\n  .second-step {\n    padding: 20px 3% 60px 3%;\n  }\n\n  .col-inpust {\n    width: 100%;\n  }\n\n}\n\n@media (max-width: 930px) {\n  .col-details {\n    display: none;\n  }\n\n  .col-details-mobile {\n    display: block;\n  }\n\n  .col-inpust {\n    width: 100%;\n    flex: 1;\n    max-width: none;\n  }\n  .usa-select-input-provider {\n    height: auto;\n  }\n\n  .actions-container {\n    margin-top: 20px;\n  }\n  .col-container {\n    justify-content: space-around;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
